// Import the functions you need from the SDKs you need
import { initializeApp, FirebaseApp } from "firebase/app";
import {
    getAnalytics,
    setUserProperties,
    logEvent as firebaseLogEvent,
    Analytics,
    CustomParams,
} from "firebase/analytics"; // 导入 Analytics 类型
import { isPro } from "~/config";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyCNDSssDX-qIMANO-YBFYcUYt5RPluKNKg",
    authDomain: "uxuy-dex.firebaseapp.com",
    projectId: "uxuy-dex",
    storageBucket: "uxuy-dex.firebasestorage.app",
    messagingSenderId: "849967776511",
    appId: "1:849967776511:web:f90ccd6cec962148f902ca",
    measurementId: "G-7TDX53RNMN",
};

let firebaseApp: FirebaseApp | null = null;
let firebaseAnalytics: Analytics | null = null;

export const setupFirebase = () => {
    if (!isPro) return;
    // Initialize Firebase
    firebaseApp = initializeApp(firebaseConfig, {
        automaticDataCollectionEnabled: true,
    });
    firebaseAnalytics = getAnalytics(firebaseApp);
};

export const setupUserProperties = (properties: CustomParams) => {
    if (firebaseApp && firebaseAnalytics) {
        setUserProperties(firebaseAnalytics, properties);
    }
};

export function xyLogEvent(eventName: string, args?: object): void {
    if (firebaseApp && firebaseAnalytics) {
        firebaseLogEvent(firebaseAnalytics, eventName, args);
    }
}
